export class DateRange {
    gte?: Date;
    lt?: Date;
}